module.exports = __webpack_public_path__ + "img/13.6fa0473d.jpg";